import { render, staticRenderFns } from "./InboundForm.vue?vue&type=template&id=6ccb0374&"
import script from "./InboundForm.vue?vue&type=script&lang=js&"
export * from "./InboundForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports